import React, { useContext } from 'react';

export const defaultSvgContext = {
  width: 0,
  height: 400,
};

export const SvgContext = React.createContext(defaultSvgContext);

function useCommonContext() {
  return useContext(SvgContext);
}

export default useCommonContext;
